import { render } from "./SemLanding.vue?vue&type=template&id=4edc4b1f&scoped=true"
import script from "./SemLanding.vue?vue&type=script&lang=js"
export * from "./SemLanding.vue?vue&type=script&lang=js"

import "./SemLanding.vue?vue&type=style&index=0&id=4edc4b1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edc4b1f"]])

export default __exports__